import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import FairnessResults from "components/Monitoring/FairnessResults";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

class FairnessResultsContainer extends React.Component {
  render() {
    const { isNext } = this.props;
    return <FairnessResults {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateMonitorViewMode: (mode) => dispatch(monitoringReducer.updateMonitorViewMode(ownProps.id, mode))
  };
};

const mapStateToProps = (state, ownProps) => {
  const overallRunId = projectReducer.getOverallRunId(state, ownProps.id);

  const fairnessPlot = monitoringReducer.getFairnessPlot(state, ownProps.id);

  return {
    fairnessPlot: fairnessPlot,
    fairnessWarnings: monitoringReducer.getfairnessWarnings(state, ownProps.id, fairnessPlot),
    fairnessObjective: setupReducer.getFairnessObjective(state, overallRunId),
    fairnessToleranceBound: setupReducer.getFairnessToleranceBound(state, overallRunId),
    setupLabels: setupReducer.getSetupLabels(state, overallRunId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(FairnessResultsContainer);
